



















import { VALID, CHANGE_ACTIVE, SET_OFFER_DATA } from '@/store/modules/offersModule';
import eventBus, { EVENTS_TYPE } from '@/services/eventbus';
import offerMixins from '@/helpers/offers/offerMixin';
import Lanes from './offersSetOne/lanes.vue';
import MasterInfoFirst from './offersSetOne/masterInfoFirst.vue';
import MasterInfoSecond from './offersSetOne/masterInfoSecond.vue';

export default {
    mixins: [offerMixins],
    components: {
        Lanes,
        MasterInfoFirst,
        MasterInfoSecond,
    },
    data(this: any) {
        return {
            rules: {
                owner: [
                    {
                        required: true,
                        message: this.$t('offer.pls_entr_name'),
                        trigger: ['blur', 'change'],
                    },
                ],
                date: [
                    {
                        type: 'date',
                        required: true,
                        message: this.$t('offer.pls_pick_date'),
                        trigger: 'change',
                    },
                ],
                validityDate: [
                    {
                        type: 'date',
                        required: true,
                        message: this.$t('offer.pls_pick_date'),
                        trigger: 'change',
                    },
                ],
                'customer.name': [
                    {
                        required: true,
                        message: this.$t('offer.pls_entr_name'),
                        trigger: ['blur', 'change'],
                    },
                ],
                'customer.contact.name': [
                    { required: true, message: this.$t('offer.requird'), trigger: ['blur', 'change'] },
                ],
            },
        };
    },

    created(this: any) {
        this.$store.commit(CHANGE_ACTIVE, 0);
        const offerId = this.$route.query.id;
        if (offerId) {
            this.$store.dispatch(SET_OFFER_DATA, offerId);
        }
    },

    mounted(this: any) {
        eventBus.$on(EVENTS_TYPE.VALID_TYPE, this.checkField);
    },

    methods: {
        checkField(this: any, value: any) {
            this.$refs.offersData.validate((valid: any) => {
                this.$store.commit(VALID, valid);
                return valid;
            });
        },

    },

    beforeDestroy(this: any) {
        eventBus.$off(EVENTS_TYPE.VALID_TYPE);
    },
};
